import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import useWorkspaceStore from '@/stores/WorkspaceStore';
import { LANGUAGE } from '@/types/commonConst';

/**
 * workspace 언어 설정에 따라 i18n 언어를 동기화하는 훅
 * workspace 언어가 'ko'인 경우만 ko, 나머지는 모두 en
 */
export function useWorkspaceLanguageSync() {
  const { i18n } = useTranslation();
  const workspaceLang = useWorkspaceStore(
    (state) => state.currWorkspace?.language,
  );

  useEffect(() => {
    const targetLang =
      workspaceLang === LANGUAGE.KO ? LANGUAGE.KO : LANGUAGE.EN;
    if (i18n.language !== targetLang) {
      i18n.changeLanguage(targetLang);
    }
  }, [workspaceLang, i18n]);
}
